import { render, staticRenderFns } from "./HoldLogAdmin.vue?vue&type=template&id=566d3bdf&scoped=true"
import script from "./HoldLogAdmin.vue?vue&type=script&lang=js"
export * from "./HoldLogAdmin.vue?vue&type=script&lang=js"
import style0 from "./HoldLogAdmin.vue?vue&type=style&index=0&id=566d3bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d3bdf",
  null
  
)

export default component.exports